var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 10.5133L11.12 13L10.0267 8.31331L13.6667 5.15998L8.87337 4.75331L7.00004 0.333313L5.12671 4.75331L0.333374 5.15998L3.97337 8.31331L2.88004 13L7.00004 10.5133Z",
    fill: "#EFC441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatIcon);
export default __webpack_public_path__ + "static/media/stat_icon.ea7d4f0bb4a7a8c6b65e7066843c34db.svg";
export { ForwardRef as ReactComponent };